import { apiService } from "@base/configs";
import httpService from "@base/services/httpService";
import { ISurveyGroup, ISurveyQuestion } from "./checkoutSurvey.interface";

class CheckoutSurveyService {
  /** The survey's questions, without their answers. Not filtered by `active`: the live group is inactive. */
  getGroup(groupCode: string, lang: string) {
    return httpService.get<ISurveyGroup>(`${apiService.utils.interviewSetting.groupByCode}/${groupCode}`, { params: { lang } });
  }

  /** One question with its answers. */
  getQuestion(questionCode: string, lang: string) {
    return httpService.get<ISurveyQuestion>(`${apiService.utils.interviewSetting.questionByCode}/${questionCode}`, { params: { lang } });
  }
}

export default new CheckoutSurveyService();
